/*
 * @Descripttion:
 * @version:
 * @Author: pengmiaopei
 * @Date: 2021-07-24 15:21:44
 * @LastEditors: pengmiaopei pengmiaopei@sinoma-tianjin.cn
 * @LastEditTime: 2023-01-10 17:31:08
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\utils\accessToken.js
 */
import Cookies from 'js-cookie';

//const TokenKey = 'Admin-Token'
export const TokenKey = 'tp_token';

const userInfoKey = 'info';

export function getAccessToken() {
  return Cookies.get(TokenKey);
}

export function setAccessToken(token) {
  // let expireTime = new Date(new Date().getTime() + 110 * 60 * 1000);
  let expireTime = 95 / 1200; // 1.9 小时
  return Cookies.set(TokenKey, token, { expires: expireTime });
}

export function removeAccessToken() {
  return Cookies.remove(TokenKey);
}

export function getUserInfo() {
  return Cookies.get(userInfoKey);
}

export function setUserInfo(info) {
  return Cookies.set(userInfoKey, info);
}

export function removeUserInfo() {
  return Cookies.remove(userInfoKey);
}

//清除所有cookie函数
export function clearAllCookie() {
  let index1 = document.domain.indexOf('.');
  let index2 = document.domain.length;
  let suffix = document.domain.substring(index1, index2); //后缀名
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--; ) {
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();
      document.cookie = keys[i] + '=0;path=/;domain=' + suffix + ';expires=' + new Date(0).toUTCString();
    }
  }
}
